import React, { useState } from "react";
import { Modal, Button, TextArea } from "@hid-galaxy-ui/galaxy-react";
import "./Modals.scss";

interface HIDCommentsModalProps {
  comments: string;
  onSave: (comments: string) => void;
  onClose: () => void;
  isReadOnly?: boolean;
}

const HIDCommentsModal: React.FC<HIDCommentsModalProps> = ({
  comments,
  onSave,
  onClose,
  isReadOnly = false,
}) => {
  const [value, setValue] = useState(comments);
  const maxLength = 1000;

  const handleSave = () => {
    onSave(value);
  };

  return (
    <Modal
      headerText="HID Comments"
      width={600}
      onClose={onClose}
      className="comments-modal"
    >
      <div className="modal-content">
        <TextArea
          id="hid-comments"
          label="Comments"
          name="hid-comments"
          placeholder={isReadOnly ? "" : "Enter your comments here..."}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setValue(e.currentTarget.value)}
          theme="dark"
          maxLength={maxLength}
          disabled={isReadOnly}
        />
        <div className="modal-footer">
          <Button
            variant="secondary"
            label="CANCEL"
            normalCase={false}
            onClick={onClose}
          />
          {!isReadOnly && (
            <Button
              variant="primary"
              label="SAVE"
              normalCase={false}
              onClick={handleSave}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default HIDCommentsModal;

